import apiClient from "../services/apiClient";

const getDemoUser = async () => {
  const payload_email = {
    email_id: "dialgriddemo@yopmail.com",
  };
  await apiClient.post("/authUser", payload_email);

  const payload_otp = {
    email_id: "dialgriddemo@yopmail.com", // Send the email received from parent component
    otp: "092500", // Send the OTP entered by the user
  };

  try {
    const response = await apiClient.post(
      "/authUser", // Update with your backend URL
      payload_otp
    );

    return response;
  } catch (err) {
    console.log("err: ", err);
  }
};

export default getDemoUser;
